import { Directive, HostListener, Input } from '@angular/core';
import { EventsService } from '@app/_services/events.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EMPTY, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';

@UntilDestroy()
@Directive({
    selector: '[eventCollector]',
    providers: [EventsService],
    standalone: true
})
export class EventCollectorDirective {
    @Input() eventName = '';
    @Input() category = '';
    @Input() type = '';
    @Input() value = '';
    @Input() itemType = '';
    @Input() companyId = '';
    @Input() categoryId = '';
    @Input() sectorId = '';
    @Input() productId = '';
    @Input() itemId = '';
    @Input() productIds = '';
    constructor(private eventsService: EventsService) {

    }

    @HostListener('click', ['$event.target'])
    onClick(btn) {
        this.eventsService.debouncer.next({
            ...(this.eventName) ? { name: this.eventName } : {},
            ...(this.category) ? { category: this.category } : {},
            ...(this.type) ? { type: this.type } : {},
            ...(this.value) ? { value: this.value } : {},
            ...(this.itemType) ? { itemType: this.itemType } : {},
            ...(this.productId) ? { productId: this.productId } : {},
            ...(this.companyId) ? { companyId: this.companyId } : {},
            ...(this.categoryId) ? { categoryId: this.categoryId } : {},
            ...(this.sectorId) ? { sectorId: this.sectorId } : {},
            ...(this.itemId) ? { itemId: this.itemId } : {},
            ...(this.productIds) ? { productIds: this.productIds } : {},
        });
    }
}